import React from 'react';
import { Menu } from '@headlessui/react';
import {
    MagnifyingGlassIcon,
    CubeIcon,
    ChartBarIcon,
    ChatBubbleLeftRightIcon,
    BellIcon,
} from '@heroicons/react/24/outline';
import { AppsMenu } from './AppsMenu';
import { MegaMenu } from './MegaMenu';

const navItems = [
    { label: 'Dashboard', active: true },
    { label: 'Crafted' },
    { label: 'Apps' },
    { label: 'Layouts' },
    { label: 'Resources' },
    { label: 'Mega Menu' },
];

export default function Header() {
    return (
        <header className="bg-[#161623] text-white px-6 py-3 flex items-center justify-between shadow-md z-50">
            {/* Left - Nav */}
            <nav className="flex gap-6 items-center">
                {navItems.map((item) =>
                    item.label === 'Apps' ? (
                        <AppsMenu key={item.label} />
                    ) : item.label === 'Mega Menu' ? (
                        <MegaMenu key={item.label} />
                    ) : (
                        <button
                            key={item.label}
                            className={`text-sm font-medium ${item.active ? 'text-white font-bold' : 'text-gray-400 hover:text-white'
                                }`}
                        >
                            {item.label}
                        </button>
                    )
                )}
            </nav>

            {/* Right - Icons */}
            <div className="flex gap-6 items-center">
                <IconButton icon={<MagnifyingGlassIcon className="w-5 h-5" />} />
                <IconButton icon={<CubeIcon className="w-5 h-5" />} />
                <IconButton icon={<ChartBarIcon className="w-5 h-5" />} />
                <IconButton icon={<ChatBubbleLeftRightIcon className="w-5 h-5" />} />
                <IconButton icon={<BellIcon className="w-5 h-5" />} />
                <img
                    src="https://randomuser.me/api/portraits/men/75.jpg"
                    alt="Profile"
                    className="w-8 h-8 rounded-full border-2 border-white object-cover"
                />
            </div>
        </header>
    );
}

function IconButton({ icon }) {
    return (
        <button className="text-gray-400 hover:text-white transition-colors">
            {icon}
        </button>
    );
}


// import React from "react";

// import { useEffect } from "react";
// import { useState } from "react";
// import { useNavigate, Link, useParams } from "react-router-dom"


// function Header() {


//     return (
//         <>
//             <section style={{ boxShadow: "0 6px 6px -6px #777" }}>
//                 <div class="navi" >
//                     <input type="checkbox" id="nav-check" />
//                     <div class="nav-header">
//                         <div class="nav-title">
//                             <Link to="/"> <img src="/images/youvati_logo.webp" alt="" style={{ height: "27px", marginLeft: "2rem" }} /></Link>
//                         </div>
//                     </div>


//                 </div>
//             </section>
//         </>
//     )
// }

// export default Header;